import React from 'react';
import {EventItemSideBarOtherEvents} from "./EventItemSideBarOtherEvents";
import PropTypes from "prop-types";



export const EventItemSideBar = ({isLoading, post, other}) => {

    return (
        <>
            {!isLoading && other.length > 0 && <EventItemSideBarOtherEvents other={other}/>}
        </>
    )
}

EventItemSideBar.propTypes = {
    isLoading: PropTypes.bool,
    post: PropTypes.object,
    other: PropTypes.array
}